import React from 'react';

import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

import { PARENT_PRODUCTS } from '../common/constants';

import ConfluencePagePreviewPanel from './confluence-page-preview-panel';

export const useConfluencePagePreviewPanel = (
	title: string,
	url: string,
	parentProduct: (typeof PARENT_PRODUCTS)[keyof typeof PARENT_PRODUCTS],
) => {
	const { open, close } = usePreviewPanelsActions();

	const openConfluencePagePreviewPanel = () => {
		open({
			panel: {
				id: `confluence-page-preview-panel-${title}`,
				content: () => (
					<ConfluencePagePreviewPanel
						props={{ title, url, parentProduct }}
						entryPoints={{}}
						extraProps={{}}
						queries={{}}
					/>
				),
			},
		});
	};

	const closeConfluencePagePreviewPanel = () => {
		const onClose = () => {};
		close(onClose);
	};

	return { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel };
};
